import { render } from "./IconEmbedPlayerMode.vue?vue&type=template&id=7213d87e"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconEmbedPlayerMode.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7213d87e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7213d87e', __exports__)) {
    api.reload('7213d87e', __exports__)
  }
  
  module.hot.accept("./IconEmbedPlayerMode.vue?vue&type=template&id=7213d87e", () => {
    api.rerender('7213d87e', render)
  })

}


export default __exports__